var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDartProgrammingLanguageLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-65.2875 -34.03 565.825 204.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.2 19.61h27.55c9.35 0 17.51 1.93 24.49 5.8 6.97 3.87 12.33 9.25 16.07 16.13 3.74 6.89 5.61 14.79 5.61 23.72s-1.87 16.83-5.61 23.72c-3.74 6.89-9.1 12.26-16.07 16.13-6.97 3.87-15.13 5.8-24.49 5.8H205.2zm27.55 80.99c10.8 0 19.36-3.1 25.7-9.31 6.33-6.21 9.5-14.88 9.5-26.02 0-11.14-3.17-19.81-9.5-26.02-6.33-6.21-14.9-9.31-25.7-9.31h-16.83v70.65h16.83zm62.86 9.56c-3.74-1.87-6.63-4.44-8.67-7.72-2.04-3.27-3.06-6.99-3.06-11.16 0-6.89 2.59-12.26 7.78-16.13 5.18-3.87 11.73-5.8 19.64-5.8 3.91 0 7.54.43 10.9 1.28 3.36.85 5.93 1.83 7.72 2.93v-3.95c0-4.85-1.7-8.74-5.1-11.67-3.4-2.93-7.7-4.4-12.88-4.4-3.66 0-7.01.79-10.08 2.36-3.06 1.57-5.48 3.76-7.27 6.57l-8.16-6.12c2.55-3.91 6.06-6.97 10.52-9.18s9.42-3.32 14.86-3.32c8.84 0 15.79 2.32 20.85 6.95 5.06 4.64 7.59 10.95 7.59 18.94v41.19h-10.33v-9.31h-.51c-1.87 3.15-4.68 5.82-8.42 8.03-3.74 2.21-7.95 3.32-12.63 3.32-4.75 0-9-.94-12.75-2.81zm23.98-9.56c3.14-1.87 5.65-4.38 7.52-7.52 1.87-3.14 2.81-6.59 2.81-10.33-2.04-1.36-4.55-2.47-7.52-3.32-2.98-.85-6.12-1.28-9.44-1.28-5.95 0-10.44 1.23-13.45 3.7-3.02 2.47-4.53 5.66-4.53 9.56 0 3.57 1.36 6.46 4.08 8.67 2.72 2.21 6.16 3.32 10.33 3.32 3.65 0 7.06-.93 10.2-2.8zm32.1-53.69h10.33v10.33h.51c1.53-3.83 4.12-6.8 7.78-8.93 3.65-2.12 7.65-3.19 11.99-3.19 1.87 0 3.44.13 4.72.38v11.1c-1.45-.34-3.4-.51-5.87-.51-5.53 0-10.01 1.83-13.45 5.48-3.44 3.66-5.17 8.42-5.17 14.28v36.09h-10.84zm67.32 64.76c-2.25-.86-4.14-2.03-5.68-3.51-1.7-1.64-2.98-3.55-3.83-5.71-.85-2.16-1.28-4.8-1.28-7.92V55.71h-11.35v-9.82h11.35V27.53h10.84v18.36h15.81v9.82h-15.81v36.24c0 3.65.68 6.34 2.04 8.08 1.61 1.91 3.95 2.87 7.01 2.87 2.46 0 4.85-.72 7.14-2.17v10.59c-1.28.59-2.57 1.02-3.89 1.28-1.32.26-3 .38-5.04.38-2.61-.01-5.05-.45-7.31-1.31z",
    opacity: 0.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.88 -.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.64 108.94L6.36 85.66c-2.76-2.84-4.48-6.84-4.48-10.75 0-1.81 1.02-4.64 1.79-6.27l21.49-44.77z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 28.35L86.06 5.07C84.03 3.03 79.79.59 76.21.59c-3.08 0-6.1.62-8.06 1.79L25.17 23.87zm4.48 84.17L71.73 99.09l-38.5 13.43L57.4 136.7h56.42z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.17 96.41c0 7.18.9 8.95 4.48 12.54l3.58 3.58h80.59l-39.4-44.77-49.25-43.88z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8 23.87H25.16l88.65 88.65h24.18V57l-28.65-28.65c-4.02-4.04-7.6-4.48-12.54-4.48z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54 109.84c-3.58-3.6-4.48-7.14-4.48-13.43V24.77l-.9-.9V96.4c.01 6.3.01 8.04 5.38 13.44l2.69 2.69z",
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    opacity: 0.2,
    d: "M112.92 111.63l.9.89H138V57.01l-.9-.9v55.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 28.35c-4.44-4.44-8.08-4.48-13.43-4.48H25.17l.9.9h69.85c2.66 0 9.41-.45 13.42 3.58z",
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 129.533)",
    r: 68.065,
    cy: 60.886,
    cx: 69.955,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.1 56.11l-27.76-27.76L86.06 5.07C84.03 3.03 79.79.59 76.21.59c-3.08 0-6.1.62-8.06 1.79L25.17 23.87 3.68 68.64c-.77 1.63-1.79 4.46-1.79 6.27 0 3.91 1.72 7.91 4.48 10.75l21.46 21.3c.51.63 1.11 1.27 1.83 1.98l.9.9 2.69 2.69 23.28 23.28.9.9h56.42v-24.18h24.18V57.01z",
    fill: "url(#a)",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartProgrammingLanguageLogowine);
export default __webpack_public_path__ + "static/media/Dart_(programming_language)-Logo.wine.2d448f8033858c2cdc2e73a142a67297.svg";
export { ForwardRef as ReactComponent };